import { 
    SET_ERRORS,
    POST_SETTING,
    LOADING_UI,
    CLEAR_ERRORS,
    SET_SETTING,
    LOADING_SETTING,
    SET_BANNER_RIGHT_TOP,
    SET_BANNER_RIGHT_BOTTOM,
    SET_BANNER_LEFT,
    DELETE_IMAGE_BANNER_LEFT,
    CLEAR_BANNER,
    GET_BANNER_LEFT,
    GET_BANNER_RIGHT_TOP,
    GET_BANNER_RIGHT_BOTTOM
 } from '../types';
import axios from 'axios';

//Post a brand
export const postSetting = (updateSetting) => (dispatch) => {
    dispatch({type: LOADING_UI});
    axios.post('/setting', updateSetting)
        .then(res => {
            dispatch({
                type: POST_SETTING,
                payload: res.data
            });
            dispatch(clearErrors());
        })
        .catch(err => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        })
}

export const getSetting = (settingId) => (dispatch) => {
      dispatch({type: LOADING_SETTING});
      axios
      .get(`/setting/${settingId}`)
      .then(res => {
          dispatch({
              type: SET_SETTING,
              payload: res.data
          })
      })
      .catch(err => console.log(err));
  }

export const getImageBannerRightTop = (imageUrl) => dispatch => {
    dispatch({
        type: SET_BANNER_RIGHT_TOP,
        imageUrl: imageUrl
    })
}
export const getImageBannerRightBottom = (imageUrl) => dispatch => {
    dispatch({
        type: SET_BANNER_RIGHT_BOTTOM,
        imageUrl: imageUrl
    })
}

export const getImagesBannerLeft = (imageUrl) => dispatch => {
    dispatch({
        type: SET_BANNER_LEFT,
        imageUrl: imageUrl
    })
}

export const delImageBannerLeft = (index) => dispatch => {
    dispatch({
        type: DELETE_IMAGE_BANNER_LEFT,
        index: index
    })
}

export const clearBanner = () => dispatch => {
    dispatch({
        type: CLEAR_BANNER,
    })
}

export const setImagesBannerLeft = (value) => dispatch => {
    dispatch({
        type: GET_BANNER_LEFT,
        payload: value
    })
}
export const setImagesBannerRightTop = (value) => dispatch => {
    dispatch({
        type: GET_BANNER_RIGHT_TOP,
        payload: value
    })
}
export const setImagesBannerRightBottom = (value) => dispatch => {
    dispatch({
        type: GET_BANNER_RIGHT_BOTTOM,
        payload: value
    })
}

export const clearErrors = () => dispatch => {
    dispatch({ type: CLEAR_ERRORS });
}

